import { apiClient } from "@/api";
import { TResponse } from "./chat-service";
import type { AxiosRequestConfig } from "axios";

export interface ShortlistAgent {
  agent_id: string;
  name: string;
  short_description: string;
  solution: string;
  provider: string;
  categories: string;
  application_area: string;
  selected_count: number;
  score: number;
  status: "active" | "inactive";
  main_category?: string | null;
}

interface ShortlistRes {
  target_pid: string;
  target_name: string;
  matches: ShortlistAgent[];
}

export const getShortlist = (projectId: string, config?: AxiosRequestConfig) => {
  return apiClient.get<TResponse<ShortlistRes>>(`/match-agents/${projectId}`, config);
};

interface InquiryReq {
  title: string;
  content: string;
  agent_ids?: string[];
  project_id?: string;
}

interface InquiryRes {
  id: string;
  user_id: string;
  title: string;
  content: string;
  status: string;
  admin_id: string;
  created_at: string;
  updated_at: string;
}

export const requestCustomAgent = (req: InquiryReq, config?: AxiosRequestConfig) => {
  return apiClient.post<TResponse<InquiryRes>>("/inquiries/", req, config);
};

// export const inviteToCompare = (projectId: string, agentIds: string[]) => {
//   return apiClient.post(`/projects/${projectId}/shortlist/invite`, {
//     agent_ids: agentIds,
//   });
// };
